import { render, staticRenderFns } from "./ColumnDetail.vue?vue&type=template&id=222445b4&scoped=true&"
import script from "./ColumnDetail.vue?vue&type=script&lang=ts&"
export * from "./ColumnDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222445b4",
  null
  
)

export default component.exports